import React from "react";
import { Col } from "antd";

const EditMobSeller = (props) => {
  return <Col style={{ padding: "2rem" }}>EditMobSeller Screen</Col>;
};

export default EditMobSeller;
